import { ComponentPropsWithoutRef, ReactNode } from 'react';

import { RiArrowUpLine } from '@remixicon/react';
import classNames from 'classnames';

import styles from './TableSortLabel.module.css';

export type TableSortLabelProps = Omit<
  ComponentPropsWithoutRef<'button'>,
  'type' | 'children'
> & {
  active?: boolean;
  direction?: 'asc' | 'desc';
  onClick?: () => void;
  children: ReactNode;
  className?: string;
};

export const TableSortLabel = ({
  active = false,
  direction = 'asc',
  onClick,
  children,
  className,
  ...rest
}: TableSortLabelProps) => {
  return (
    <button
      data-track-source-anchor="bb4c12dded;table-sort-label-button;low" {...rest}
      type="button"
      className={classNames(styles.root, active && styles.active, className)}
      onClick={onClick}
    >
      {children}
      <span
        className={classNames(
          styles.icon,
          direction === 'asc' && styles.iconAsc,
          direction === 'desc' && styles.iconDesc,
        )}
        aria-hidden
      >
        <RiArrowUpLine size={16} />
      </span>
    </button>
  );
};
